import { filteredNoteNodes } from '../../utility'
import { parseHtmlString } from 'ingestion/nodeCreationHelpers'

export function narrative({ narrative }: { narrative: string }) {
  if (!narrative) return []
  const asHtml = parseHtmlString(narrative)
  ;['c-annotations', 'c-annotation'].forEach((className) => {
    Array.from(asHtml.getElementsByClassName(className)).forEach((element) =>
      element.remove(),
    )
  })
  return filteredNoteNodes(['Narrative', asHtml.body.innerHTML.trim()])
}
